export default "__VITE_ASSET__Bq4ghs6b__"